import React from 'react';
import Layout from '../../components/Layout/Layout';
import LaunchedSubCategories from '../../components/LaunchedSubCategories/LaunchedSubCategories';
import styles from './LaunchedSubCategoriesPage.module.css';

const LaunchedSubCategoriesPage = () => {
  return (
    <Layout width="1440px">
      <div className={styles.launchedSubCategoriesStack}>
        <LaunchedSubCategories
          componentSize="Desktop 1440"
          selectedCategoryId={9}
        />
      </div>
    </Layout>
  );
};

export default LaunchedSubCategoriesPage;